import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './styles.css';
import 'core-js/stable';
// import 'regenerator-runtime/runtime';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';

Sentry.init({
  dsn: 'https://61576511b5d94063a605db714af13bf1@sentry.ozonecard.app/27',
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 1.0,
  integrations: [
    Sentry.replayIntegration({
      networkDetailAllowUrls: [/ozone.*\/api\//], // matches ALL API URLs
      networkRequestHeaders: ['*'], // capture all request headers
      networkResponseHeaders: ['*'], // capture all response headers
      // Additional SDK configuration goes in here, for example:
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  sendDefaultPii: true,
  debug: false,
  beforeSend(event) {
    if (event.request && typeof window !== "undefined") {
      event.request.url = window.location.href; // includes query params
    }
    return event;
  },
});
Sentry.setTag('payment-gateway-code', `${localStorage.getItem('pgc')}`);
Sentry.setTag('phoneNumber', `${sessionStorage.getItem('phoneNumber')}`);
const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(<App />);
